<template>
    <div id="share__modal">
        <div>
            <transition v-on:after-enter="afterEnter" v-on:after-leave="afterLeave">
            <div v-click-outside="handleFocusOut" v-show="show">
                <div class="share__modal__item">
                    <span  @click="$emit('link')" :style="{backgroundImage: `url('${require('@/image/icon/linkcopy.svg')}')`}"></span>
                </div>
                <div class="share__modal__item">

                    <span  @click="$emit('kakao')" :style="{backgroundImage: `url('${require('@/image/icon/btn-kakao.svg')}')`}"></span>
                </div>
                <div class="share__modal__item">

                    <span @click="$emit('band')" :style="{backgroundImage: `url('${require('@/image/icon/btn-band.svg')}')`}"></span>
                </div>
                <div class="share__modal__item">

                    <span :style="{backgroundImage: `url('${require('@/image/icon/btn-facebook.svg')}')`}" @click="$emit('facebook')"></span>
                </div>
                <div class="share__modal__item">
                    <span :style="{backgroundImage: `url('${require('@/image/icon/btn-story.svg')}')`}" @click="$emit('kakaoStory')"></span>
                </div>
            </div>
            </transition>
        </div>
    </div>
</template>
<script>
    import ClickOutside from 'vue-click-outside'

    export default {
        props: ['show'],
        methods: {
            handleFocusOut() {
                if(this.closeCheck){
                    this.$emit('close')
                }

            },
            afterEnter(){
                this.closeCheck = true
            },
            afterLeave(){
                this.closeCheck = false
            }
        },
        // do not forget this section
        directives: {
            ClickOutside
        },
        mounted() {
            this.open = true
        },
        data(){
            return{
                open: false,
                closeCheck:false
            }
        }
    }
</script>
